<template>
    <aside class="filters">
        <h1>{{ title }}</h1>
        <div class="mobile-filter__open filter__btn">

            <!--<a href="#/" @click="filterVisible = !filterVisible">-->
            <!--<span v-text="filterText"></span>-->
            <!--<span class="icon"></span>-->
            <!--</a>-->

        </div><!-- /.filter__btn -->
        <!--<div class="filter-section" :class="{visible: filterVisible}">-->

        <alf-stories-category-switcher :story-categories="storyCategories"></alf-stories-category-switcher>

        <p class="filter--pgh" v-if="activeCategory">{{ activeCategory.content }}</p>

        <!--<bhf-select ref="select" :productCategoriesData="this.productCategory"></bhf-select>-->

        <!--<a href="#" @click="filterVisible = false" class="mobile-filter__close filter-btn">{{ applyFilterText }}</a>-->

        <!--</div>&lt;!&ndash; /.filter-section &ndash;&gt;-->
    </aside><!-- /.aside -->
</template>
<script>
    import StoriesCategorySwitcher from './stories-category-switcher';
    export default {
        components: {
            'alf-stories-category-switcher': StoriesCategorySwitcher
        },
        props: {
            'storyCategories': {required: true},
            'title': {required: true}
        },
        data: function(){
            return {

            }
        },
        computed: {
            activeCategory: function(){
                if(this.$route.params.slug === undefined)
                    return;

                let self = this;
                return this.storyCategories.filter(function(category){
                    return category.slug === self.$route.params.slug;
                })[0];
            }
        }
    }
</script>
<style lang="scss" scoped>
    h1{
        font-size: 40px;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/site/components/stories/stories-sidebar.vue